// extracted by mini-css-extract-plugin
module.exports = {"BackTop":"AeMp490Y"};